export const bankpay_consumer_token = 'bankpay_consumer_token';
export const transaction = 'transaction';
export const userlogo = 'userlogo';
export const bankpay_consumer_user_id = 'bankpay_consumer_user_id';
export const baseURL =
  process.env.REACT_APP_ENV === 'staging-live'
    ? 'https://api-staging-live.joinfam.com/api/v1'
    : process.env.REACT_APP_ENV === 'staging'
    ? 'https://api-staging-dev.joinfam.com/api/v1'
    : process.env.REACT_APP_ENV === 'staging-sandbox'
    ? 'https://api-staging-sandbox.joinfam.com/api/v1'
    : process.env.REACT_APP_ENV === 'prod-live'
    ? 'https://api.joinfam.com/api/v1'
    : process.env.REACT_APP_ENV === 'prod-sandbox'
    ? 'https://api-sandbox.joinfam.com/api/v1'
    : 'https://api-staging-dev.joinfam.com/api/v1';

export const pusherKey =
  process.env.REACT_APP_ENV === 'production'
    ? '695ea8eb592ee53dea95'
    : process.env.REACT_APP_ENV === 'test'
    ? '695ea8eb592ee53dea95'
    : process.env.REACT_APP_ENV === 'staging'
    ? '695ea8eb592ee53dea95'
    : '695ea8eb592ee53dea95';

export const bankPayHomeUrl = 'https://bankpay.to/';

export const qrcodeBankLogo =
  'https://d3hj803vubzeo0.cloudfront.net/logo/qr-logo.svg';

export const bankAccountEvent = 'bank-link';
export const paymentEvent = 'checkout-process';
export const avatarUrl = 'https://ui-avatars.com/api/';
export const famPrivacy = 'https://joinfam.freshdesk.com/support/solutions/articles/103000100413-privacy-policy';
export const famTerms = 'https://joinfam.freshdesk.com/support/solutions/articles/103000100417-terms-of-use';
export const googlePrivacy = 'https://policies.google.com/privacy?hl=en-GB';
export const googleTerms = 'https://policies.google.com/terms?hl=en-GB';